import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { serviceConsumer } from '../../../../network/ServiceConsumer'
import ManageTitle from '../../../../Components/TitleElements/ManageTitle'
import HeaderOrg from '../../../Headers/HeaderOrg'
import Loader from '../../../../Components/Loader/Loader'
import Help from '../../../../Components/Help/Help'
import sort from "../../../../Assets/managefeisGrade/sort-org.svg"
import edit from "../../../../Assets/edit-comp-action.svg"
import "../../../../Components/Table.css"
import { groupAndSortComp } from '../../../../helper/SortSyllabus'
// === NEW MERGE/SPLIT FLOW: Import new modals (added March 2026) ===
// TO REVERT: Remove these imports and remove the modal rendering at the bottom of the JSX
import SplitPreviewModal from '../../../../Components/Modals/OrganizerModel/ManageFeis/Entries/SplitPreviewModal'
import MergeModal from '../../../../Components/Modals/OrganizerModel/ManageFeis/Entries/MergeModal'
import Button from '../../../../Components/Button/Button'
import ToggleSwitch from '../../../../Components/ToggleSwitch/ToggleSwitch'
// === END NEW IMPORTS ===

const MergeSplit = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const searchParams = new URLSearchParams(location.search)
    const eventId = searchParams.get('id')
    const [event, setEvent] = useState()
    const [loading, setLoading] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [responseArray, setResponseArray] = useState([])
    const [tableArr, setTableArr] = useState([])
    const [sorterData, setSorterData] = useState("")
    const [sortOrder, setSortOrder] = useState("asc")
    const [err, setErr] = useState("")
    const [savingFinal, setSavingFinal] = useState(false)

    // === NEW MERGE/SPLIT FLOW: State for inline modals (added March 2026) ===
    // TO REVERT: Remove these state variables and the modal rendering below
    const [splitModalOpen, setSplitModalOpen] = useState(false)
    const [mergeModalOpen, setMergeModalOpen] = useState(false)
    const [selectedCompetition, setSelectedCompetition] = useState(null)
    // === END NEW STATE ===

    // Merges and splits done: parents see who is in each competition only
    // after this (MC2 76145074; the same switch as the website's organizer screen)
    const setEntriesFinal = async (final) => {
        try {
            setSavingFinal(true)
            const res = await serviceConsumer('PUT', `${process.env.REACT_APP_BASE_URL}/feis/${eventId}/entries-final`, { final })
            setEvent((e) => ({ ...e, entriesFinal: !!res?.entriesFinal, entriesFinalAt: res?.entriesFinalAt }))
            setErr("")
        } catch (error) {
            setErr(error?.messages || "Could not save that")
        } finally {
            setSavingFinal(false)
        }
    }

    //get eventDetails for title and competition details for table
    const getAllDetails = async () => {
        try {
            setLoading(true)
            const eventUrl = `${process.env.REACT_APP_BASE_URL}/feis/${eventId}`
            const eventResponse = await serviceConsumer('GET', eventUrl)
            setEvent(eventResponse.Feis)
            const competitionUrl = `${process.env.REACT_APP_BASE_URL}/feis/${eventId}/competition`
            const competitionResponse = await serviceConsumer('GET', competitionUrl)
            const sortedCompetitions = groupAndSortComp(competitionResponse.competitions)
            setResponseArray(sortedCompetitions)
            setLoading(false)
        }
        catch (error) {
            navigate("/pageNotFound", { replace: true })
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllDetails()
    }, [])

    // search input in competitors
    useEffect(() => {
        const tableArr = responseArray?.filter((searching) => {
            if (searchInput === "") {
                return searching;
            } else if (
                (searching?.code?.toLowerCase().includes(searchInput?.toLowerCase())
                    || searching?.group?.toLowerCase().includes(searchInput?.toLowerCase())
                    || searching?.ages?.map(age => age.value).toString().toLowerCase().includes(searchInput?.toLowerCase())
                    || searching?.dancers?.length.toString().includes(searchInput?.toLowerCase())
                )
            ) {
                return searching;
            }
        })
        setTableArr(tableArr)
    }, [responseArray, searchInput])

    //sort competitor as per column
    const sortCompetitorsHandler = (sorter) => {
        let order = sorter === sorterData ? (sortOrder === "asc" ? "desc" : "asc") : "asc";
        order === "asc" && sorter === "competition" && tableArr.sort((a, b) => a.code.localeCompare(b.code))
        order === "asc" && sorter === "level" && tableArr.sort((a, b) => a.group.localeCompare(b.group))
        order === "asc" && sorter === "entriesMax" && tableArr.sort((a, b) => a.dancers.length - (b.dancers.length))
        order === "asc" && sorter === "ages" && tableArr.sort((a, b) => (Number(a.ages[0].value.substring(1))) - (Number(b.ages[0].value.substring(1))))


        order === "desc" && sorter === "competition" && tableArr.sort((a, b) => b.code.localeCompare(a.code));
        order === "desc" && sorter === "level" && tableArr.sort((a, b) => b.group.localeCompare(a.group));
        order === "desc" && sorter === "entriesMax" && tableArr.sort((a, b) => b.dancers.length - (a.dancers.length));
        order === "desc" && sorter === "ages" && tableArr.sort((a, b) => (Number(b.ages[0].value.substring(1))) - (Number(a.ages[0].value.substring(1))))

        setTableArr(tableArr)
        setSorterData(sorter)
        setSortOrder(order)
    }

    //edit image click handler
    const editClickHandler = (competition) => {
        navigate(`/merge-split-comp/${event?.name}?id=${event?._id}&competitionId=${competition._id}`)
    }

    // === NEW MERGE/SPLIT FLOW: Inline button handlers (added March 2026) ===
    // TO REVERT: Remove these handlers
    const handleSplitClick = (competition) => {
        setSelectedCompetition(competition)
        setSplitModalOpen(true)
    }

    const handleMergeClick = (competition) => {
        setSelectedCompetition(competition)
        setMergeModalOpen(true)
    }

    const handleModalClose = () => {
        setSplitModalOpen(false)
        setMergeModalOpen(false)
        setSelectedCompetition(null)
    }

    const handleModalSuccess = () => {
        handleModalClose()
        getAllDetails() // Refresh the competition list
    }

    const feisYear = event?.feis_date ? new Date(event.feis_date).getFullYear() : new Date().getFullYear()
    // === END NEW HANDLERS ===

    // Export the (sorted) competition list to a CSV file with columns:
    //   Sort order #, Competition, Level, Ages, Entries
    // Source data is the same array (responseArray) that drives the on-screen table,
    // so the row order in the CSV matches what the organizer sees.
    const escapeCsv = (val) => {
        const s = val == null ? "" : String(val)
        return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
    }

    const exportToCSV = () => {
        const sortedComps = responseArray?.filter(c => c) || []
        if (sortedComps.length === 0) return

        const header = ["Sort order #", "Competition", "Level", "Ages", "Entries"]
        const rows = sortedComps.map((c, i) => {
            const ages = (c?.ages || []).map(a => (typeof a === "object" ? a?.value : a)).filter(Boolean).join(", ")
            const compName = c?.code && c?.description ? `${c.code}-${c.description}` : (c?.code || c?.description || "")
            return [
                i + 1,
                compName,
                c?.group || "",
                ages,
                c?.dancers?.length ?? 0,
            ].map(escapeCsv).join(",")
        })
        const csv = [header.map(escapeCsv).join(","), ...rows].join("\n")
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
        const url = URL.createObjectURL(blob)
        const a = document.createElement("a")
        const safeName = (event?.name || "competitions").replace(/[^a-z0-9-_]+/gi, "_")
        a.href = url
        a.download = `${safeName}-competitions.csv`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
    }

    return (
        <>
            {loading && <Loader />}
            <HeaderOrg />
            <ManageTitle eventLogo={event?.logo} eventName={event?.name} eventType={event?.eventType} eventDate={event?.feis_date} loading={loading} />
            <div className="db-body">
                {!loading && <>
                    <div className="d-flex justify-content-between align-items-center pt-4">
                        <div className='org-body-title m-0'>Merge and splits</div>
                        <Button
                            className="outlined"
                            style={{ fontSize: "12px", padding: "6px 14px" }}
                            onClick={exportToCSV}
                            disabled={!responseArray || responseArray.length === 0}
                        >
                            Export to CSV
                        </Button>
                    </div>
                    <div className="mb-3 hr-org-body" />
                    <div className="d-flex align-items-center gap-3 mt-4" style={{ padding: "14px 16px", background: "#fff", borderRadius: "11px", border: "1px solid #eaeaea" }}>
                        <ToggleSwitch checked={!!event?.entriesFinal} disabled={savingFinal} onChange={(e) => setEntriesFinal(e.target.checked)} />
                        <div>
                            <div style={{ fontWeight: 500, color: "#303030" }}>Merges and splits are done</div>
                            <div style={{ fontSize: "13px", color: "#656565" }}>
                                {event?.entriesFinal
                                    ? "Parents can see who is in each competition on the competitors list."
                                    : "Turn this on when you've finished. Until then parents see the counts only, no names."}
                            </div>
                        </div>
                    </div>
                    <div className="search-label" style={{ marginTop: "33px" }}>Search:</div>
                    <input
                        type="text"
                        name="search"
                        onChange={(e) => setSearchInput(e.target.value)}
                        placeholder="Search..."
                        className="searchFeisComp"
                    />
                    <div style={{ width: "100%", overflowX: "scroll", marginTop: "30px" }}>
                        <table className="table my_table competitorTable ">
                            <tbody>
                                <tr className="header-row">
                                    <td className="ps-3 w-20 p-25-5">Competitions&nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("competition")} />
                                    </span></td>
                                    <td className=" w-20 p-25-5">Level &nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("level")} />
                                    </span></td>
                                    <td className=" w-20 p-25-5">Ages &nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("ages")} />
                                    </span></td>
                                    <td className=" w-20 p-25-5 text-center"># Entries &nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("entriesMax")} />
                                    </span></td>
                                    <td className="px-0 w-20 p-25-5 text-center">Merge and split</td>
                                </tr>
                                {tableArr?.filter(comp => comp.dancers.length > 0).map((competition, index) => {
                                    let background = competition.dancers.length > 15 ? "#FFE1E1" : "#ffffff";
                                    const hasMultipleAges = competition?.ages?.length > 1
                                    return <tr key={index} style={{ background: background, fontSize: "12px", height: "40px" }}>
                                        <td className=" ps-3 w-20 grey-30"><div>{competition?.code}-{competition?.description}<div>{competition?._id}</div></div></td>
                                        <td className=" w-20 grey-30">{competition?.group}</td>
                                        <td className=" w-20 grey-30">{competition?.ages?.map((item, index) => { return (competition?.ages?.length === index + 1) ? item : `${item}, ` })}</td>
                                        <td className=" w-20 grey-30 text-center">{competition?.dancers?.length}</td>

                                        {/* === OLD MERGE/SPLIT FLOW (commented out — DO NOT DELETE) === */}
                                        {/* TO REVERT: Uncomment this <td> and comment out the NEW FLOW <td> below */}
                                        {/* <td className=" px-0 w-20 grey-30 text-center"><img className="cursor-pointer" onClick={() => editClickHandler(competition)} src={edit} alt="edit" /></td> */}
                                        {/* === END OLD FLOW === */}

                                        {/* === NEW MERGE/SPLIT FLOW: Inline Merge/Split buttons + edit icon (added March 2026) === */}
                                        {/* TO REVERT TO OLD: Comment out this <td> and uncomment the OLD FLOW <td> above */}
                                        <td className="px-0 w-20 grey-30 text-center">
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <Button
                                                    className="filled"
                                                    style={{ fontSize: "11px", padding: "4px 12px", minWidth: "60px" }}
                                                    onClick={() => handleMergeClick(competition)}
                                                >
                                                    Merge
                                                </Button>
                                                <Button
                                                    className={hasMultipleAges ? "filled" : "disabled"}
                                                    style={{ fontSize: "11px", padding: "4px 12px", minWidth: "60px" }}
                                                    disabled={!hasMultipleAges}
                                                    onClick={() => hasMultipleAges && handleSplitClick(competition)}
                                                >
                                                    Split
                                                </Button>
                                                <img className="cursor-pointer" onClick={() => editClickHandler(competition)} src={edit} alt="edit" />
                                            </div>
                                        </td>
                                        {/* === END NEW FLOW === */}
                                    </tr>
                                })}
                            </tbody>
                        </table>
                        {!loading && responseArray.length > 0 && tableArr?.length === 0 && searchInput !== "" && <div className="d-flex justify-content-center my-5">There are no competitors matching your search</div>}
                        {!loading && responseArray.length === 0 && <div className="d-flex justify-content-center my-5">There are no competitors registered for this event</div>}
                        {!loading && err && <div className="d-flex justify-content-center error-class">{err}</div>}
                    </div>
                </>}
            </div>

            {/* === NEW MERGE/SPLIT FLOW: Modal rendering (added March 2026) === */}
            {/* TO REVERT: Remove this entire block. Old modals are rendered in MergeSplitFn.jsx via edit icon. */}
            {splitModalOpen && selectedCompetition && (
                <SplitPreviewModal
                    modalState={true}
                    competition={selectedCompetition}
                    feisYear={feisYear}
                    onClose={handleModalClose}
                    onSuccess={handleModalSuccess}
                />
            )}
            {mergeModalOpen && selectedCompetition && (
                <MergeModal
                    modalState={true}
                    competition={selectedCompetition}
                    eventId={eventId}
                    onClose={handleModalClose}
                    onSuccess={handleModalSuccess}
                />
            )}
            {/* === END NEW MODAL RENDERING === */}

            <Help />
        </>
    )
}

export default MergeSplit
